define((require) => {
    "use strict";

    var AnimationPropertiesView       = require("ui/experience/widgets/animations/AnimationPropertiesView"),
        ColorPicker                   = require("shared/services/ColorPicker"),
        SizeAndPositionPropertiesView = require("ui/experience/widgets/SizeAndPositionPropertiesView"),
        StylePropertiesView           = require("ui/experience/widgets/StylePropertiesView"),
        template                      = require("ui/experience/widgets/shapeWidget/ShapeWidgetPropertiesView.tpl"),
        AbstractWidgetPropertiesView  = require("ui/experience/widgets/AbstractWidgetPropertiesView");

    const EXPAND_PROPERTY = "shapeExpanded";

    /**
     * The properties view for a shape widget.
     *
     * @class ShapeWidgetPropertiesView
     * @constructor
     *
     * @cfg {ShapeWidgetModel} model The model for the shape widget being edited.
     */
    return AbstractWidgetPropertiesView.extend({

        expandProperty: EXPAND_PROPERTY,

        template: template,

        _backgroundColorPicker: null,

        ui: {
            legend: "[data-target=\".shape-properties-container\"]",
            shapeProperties: ".shape-properties-container",
            shapeBackgroundColorInput: ".shape-background-color-input",
            shapeBackgroundColorBox: ".shape-background-color-box",
            shapeColorLibrary: ".shape-background-color-library"
        },

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            styleProperties: ".style-properties",
            animationProperties: ".animation-properties"
        },

        bindings: {
            ".shape-background-color-input": {
                observe: "backgroundColor",
                onSet: function(color) {
                    return this._backgroundColorPicker.hexOrDefault(color);
                }
            }
        },

        onClose: function() {
            this._backgroundColorPicker.dispose();
        },

        onRender: function() {
            this.__super();

            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                widgetView: this.options.widgetView
            }));
            this.styleProperties.show(new StylePropertiesView({model: this.model, hideOpacityControls: false, hideRadiusControls: false}));
            this.animationProperties.show(new AnimationPropertiesView({model: this.model, widgetView: this.options.widgetView}));
            this._backgroundColorPicker = new ColorPicker({
                color: this.model.get("backgroundColor"),
                input: this.ui.shapeBackgroundColorInput,
                colorBox: this.ui.shapeBackgroundColorBox,
                library: this.ui.shapeColorLibrary,
                includeTransparency: true,
                tracking: "colorpicker:box"
            });
        }
    }, {
        EXPAND_PROPERTY
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/shapeWidget/ShapeWidgetPropertiesView.js